import type { CmsContentId } from '@zep/next';

export const CmsEntries = {
  BANNERS: {
    ko: '3ee8007f-fff3-48a5-b09e-925778691b8b',
    en: '8c50e659-fcfc-402b-93e0-0b517918215c',
    ja: '5a079d27-f77b-4a26-ab67-815f05e582fc',
  },
  EXPLORE: {
    ko: '2572f3b3-26d7-4a20-a849-37ffb16c8fe1',
    en: '386fa5b7-6d17-41e9-a8a8-b39699df4d61',
    ja: 'e20aa8c0-6591-443e-89f5-03ee59bb3a83',
  },
  // 요금제 페이지 데이터 (CMS 제목: 코어_프라이싱_한/영/일)
  PRICING: {
    ko: '88e9fbf9-c33e-4ff3-bd80-7dd7ef6b7665',
    en: '8d2fe62c-34cc-4621-9da7-99800cb0eea2',
    ja: '4b569e25-f93e-4a22-af3b-9852c95bc757',
  },
  // 코어 랜딩 /home/landing (CMS 제목: 코어_랜딩_한/영/일)
  LANDING_PAGE: {
    ko: '5d4acf38-9467-45fe-8c13-1473010a602c',
    en: '711f3f64-166f-4568-9cb8-d02921ddaa65',
    ja: '43ad9abe-49e8-4294-ba99-71a88359ecaf',
  },
  // KDT 랜딩 /home/onlineclass (CMS 제목: KDT_랜딩_한/영/일)
  ONLINE_CLASS_PAGE: {
    ko: 'ac029a9b-aaf8-41e2-94ce-f23e119ca268',
    en: '38a69b69-7bf8-4eaa-b2d7-b8d276d8ea82',
    ja: '7af66de2-7c39-4b29-8c30-2d15530b220b',
  },
  // 행사 랜딩 /home/event (CMS 제목: 행사_랜딩_한/영/일)
  EVENT_PAGE: {
    ko: '515d8414-9c3e-4b95-b86e-77c4d2d8fc9c',
    en: '7e90473c-61d2-4cb3-ac6c-4c4a1ba3b467',
    ja: '32467290-47b3-4c20-a1e9-8cebdc84d747',
  },
  // 브랜딩 랜딩 /home/branding (CMS 제목: 브랜딩_랜딩_한/영/일)
  BRANDING_PAGE: {
    ko: 'c5f3901f-d6a3-4fb8-8208-41c26120d646',
    en: 'd345a043-eeca-4ffd-b559-acbb8765a2f3',
    ja: 'a7981acf-09c3-48a2-ac36-5a154a432cfd',
  },
  // HRD 랜딩 /home/hrd (CMS 제목: HRD_랜딩_한/영/일)
  HRD_PAGE: {
    ko: '15576d93-db08-4d83-8110-5028fef0ac97',
    en: '740c6e94-ed48-4ae7-80b7-ecd230eb61e8',
    ja: '6d0c3da1-be10-432f-b32f-2a30dffd6121',
  },
  // 스쿨 랜딩 /home/school (CMS 제목: 스쿨_랜딩_한/영/일)
  SCHOOL_PAGE: {
    ko: 'f4be77f9-4206-497d-9b89-38340765b376',
    en: 'dfc0af2b-e848-4943-a3cd-406cc454bff2',
    ja: 'db941434-f5ea-426a-9b98-6418da8ead5a',
  },
  // 오피스 랜딩 /home/office (CMS 제목: 오피스_랜딩_한/영/일)
  OFFICE_PAGE: {
    ko: '6416c9ac-4228-4ee1-bdfb-e8205b6547d3',
    en: 'cb57c5d0-6553-45a7-89a5-19e098f09821',
    ja: 'aa6ec1ea-0eab-49bb-a876-030ca2b425be',
  },
  // 에셋 스토어 추천 에셋 (CMS 제목: 스토어_추천에셋_한/영/일)
  STORE_RECOMMEND_ASSETS: {
    ko: '403364c4-a83b-45dc-b7e9-f79add3def20',
    en: 'd9e24a18-e410-44d7-8cd6-c84954f03de2',
    ja: '1ec1e952-83a1-45e9-9c64-818be57c595e',
  },
  // 앱스토어 추천 앱 (CMS 제목: 스토어_추천앱_한/영). 위글루 원본에 ja 가 없어
  // ja 는 영문 콘텐츠를 가리킨다 — 위글루 CDA 의 en-US 폴백과 동일한 동작.
  STORE_RECOMMEND_APPS: {
    ko: 'ed0b80cb-df3d-46ad-8cfa-0fed8f9b09c3',
    en: '50e2e432-c213-41e6-bd70-241ee64cc429',
    ja: '50e2e432-c213-41e6-bd70-241ee64cc429',
  },
  // 교육용 에셋 스토어 추천 에셋 (CMS 제목: 스토어_추천에셋_에듀_한/영). ja=en 폴백
  STORE_RECOMMEND_ASSETS_EDU: {
    ko: 'dc34d640-e7d5-4119-b4a6-8e4247f57eb8',
    en: 'b58589f4-4235-4914-a1d8-329cdca27b65',
    ja: 'b58589f4-4235-4914-a1d8-329cdca27b65',
  },
  // 교육용 앱스토어 추천 앱 (CMS 제목: 스토어_추천앱_에듀_한/영). ja=en 폴백
  STORE_RECOMMEND_APPS_EDU: {
    ko: '2922d361-c382-45d9-a0c9-45e305a8a11e',
    en: '3078df1d-436e-4d34-87f5-ac63483ad86a',
    ja: '3078df1d-436e-4d34-87f5-ac63483ad86a',
  },
  // 에셋 스토어 구축 문의 배너 (CMS 제목: 스토어_구축문의배너_한/영/일)
  STORE_INQUIRY_BANNERS: {
    ko: '3d41de52-16f1-4637-b455-b74a7d49cb2a',
    en: '4436d919-5a65-41e2-847b-fc1b849efbcd',
    ja: '08cf8487-9263-4227-b97c-dd83ac29a5b0',
  },
} as const satisfies Record<string, CmsContentId>;
